import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
  listarRecomendacoes,
  contarRecomendacoes,
  marcarEmPedido,
  marcarIgnorado,
  reabrir,
  obterConfig,
  atualizarConfig,
  executarAgora,
} from '../../../services/recomendacaoService';

const initialState = {
  lista: [],
  contadores: {
    total_pendentes: 0, criticas: 0, altas: 0, medias: 0, baixas: 0,
    produtos_a: 0, produtos_b: 0, produtos_c: 0,
    valor_total_estimado: 0,
  },
  config: null,
  filtros: { status: '', severidade: '', abc: '', limit: 50, offset: 0 },
  loadingLista: false,
  loadingContadores: false,
  loadingConfig: false,
  executando: false,
  error: null,
};

export const fetchRecomendacoes = createAsyncThunk(
  'recomendacao/fetchLista',
  async (params, { getState }) => {
    const merged = { ...getState().recomendacaoReducer.filtros, ...(params || {}) };
    return listarRecomendacoes(merged);
  },
);

export const fetchContadores = createAsyncThunk(
  'recomendacao/fetchContadores',
  async () => contarRecomendacoes(),
);

export const fetchConfig = createAsyncThunk(
  'recomendacao/fetchConfig',
  async () => obterConfig(),
);

export const atualizarConfigThunk = createAsyncThunk(
  'recomendacao/atualizarConfig',
  async (payload, { dispatch }) => {
    const resp = await atualizarConfig(payload);
    dispatch(fetchConfig());
    return resp;
  },
);

export const marcarEmPedidoThunk = createAsyncThunk(
  'recomendacao/marcarEmPedido',
  async ({ id, observacao }, { dispatch }) => {
    const resp = await marcarEmPedido(id, observacao);
    dispatch(fetchContadores());
    return { id, resp };
  },
);

export const marcarIgnoradoThunk = createAsyncThunk(
  'recomendacao/marcarIgnorado',
  async ({ id, observacao }, { dispatch }) => {
    const resp = await marcarIgnorado(id, observacao);
    dispatch(fetchContadores());
    return { id, resp };
  },
);

export const reabrirThunk = createAsyncThunk(
  'recomendacao/reabrir',
  async (id, { dispatch }) => {
    const resp = await reabrir(id);
    dispatch(fetchContadores());
    dispatch(fetchRecomendacoes());
    return { id, resp };
  },
);

export const executarAgoraThunk = createAsyncThunk(
  'recomendacao/executar',
  async (_, { dispatch }) => {
    const resp = await executarAgora();
    dispatch(fetchContadores());
    dispatch(fetchRecomendacoes());
    return resp;
  },
);

const RecomendacaoSlice = createSlice({
  name: 'recomendacao',
  initialState,
  reducers: {
    setFiltros: (s, a) => {
      s.filtros = { ...s.filtros, ...a.payload };
    },
    limparErro: (s) => { s.error = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRecomendacoes.pending, (s) => { s.loadingLista = true; s.error = null; })
      .addCase(fetchRecomendacoes.fulfilled, (s, a) => {
        s.loadingLista = false;
        s.lista = a.payload || [];
      })
      .addCase(fetchRecomendacoes.rejected, (s, a) => {
        s.loadingLista = false;
        s.error = a.error?.message || 'Falha ao carregar recomendações';
      })

      .addCase(fetchContadores.pending, (s) => { s.loadingContadores = true; })
      .addCase(fetchContadores.fulfilled, (s, a) => {
        s.loadingContadores = false;
        s.contadores = a.payload || initialState.contadores;
      })
      .addCase(fetchContadores.rejected, (s) => { s.loadingContadores = false; })

      .addCase(fetchConfig.pending, (s) => { s.loadingConfig = true; })
      .addCase(fetchConfig.fulfilled, (s, a) => {
        s.loadingConfig = false;
        s.config = a.payload;
      })
      .addCase(fetchConfig.rejected, (s, a) => {
        s.loadingConfig = false;
        s.error = a.error?.message || 'Falha ao carregar configuração';
      })

      .addCase(marcarEmPedidoThunk.fulfilled, (s, a) => {
        s.lista = s.lista.filter((r) => r.id !== a.payload.id);
      })
      .addCase(marcarIgnoradoThunk.fulfilled, (s, a) => {
        s.lista = s.lista.filter((r) => r.id !== a.payload.id);
      })

      .addCase(executarAgoraThunk.pending, (s) => { s.executando = true; })
      .addCase(executarAgoraThunk.fulfilled, (s) => { s.executando = false; })
      .addCase(executarAgoraThunk.rejected, (s, a) => {
        s.executando = false;
        s.error = a.error?.message || 'Falha ao executar';
      });
  },
});

export const { setFiltros, limparErro } = RecomendacaoSlice.actions;
export default RecomendacaoSlice.reducer;
